import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationSummaryPage} from 'features/deposit/onboarding/pages/DepositApplicationSummaryPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId/summary',
)({
  component: DepositApplicationSummaryPage,
});
